import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMergerMode = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.0019532,
			d: "M100.843 930.12V93.94H937.01"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.0019532,
			d: "M931.01 93.94c-171.39 20.2-322.854 196.256-340.352 294.539-31.362 176.193-192.266 154.281-249 305.965-32.478 86.844-98.088 177.251-240.815 234.56"
		}),
		/* @__PURE__ */ _jsx("path", { d: "m440.046 261.333 28.637 200.465L268.22 433.16z" }),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72,
			d: "M157.683 150.79 377.05 370.158",
			transform: "matrix(1 0 0 1 -.008 -.001)"
		}),
		/* @__PURE__ */ _jsx("path", { d: "m594.61 745.092-28.638-200.465 200.465 28.638z" }),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72,
			d: "M876.982 855.626 657.615 636.259",
			transform: "matrix(1 0 0 1 -.002 .01)"
		})
	]
});
export default SvgIconMergerMode;
